import { Dialog, DialogProps } from '@mui/material';
import { CSSProperties } from 'react';

interface IModalProps extends Partial<Omit<DialogProps, 'css' | 'maxWidth'>> {
  maxWidth?: number | string;
  style?: CSSProperties;
}

export const Modal: React.FC<React.PropsWithChildren<IModalProps>> = (props) => {
  const { open = false, maxWidth, style, children, ...rest } = props;

  return (
    <Dialog
      {...rest}
      open={open}
      sx={{
        ...style,
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.3)'
        },
        '& .MuiDialog-paper': {
          maxWidth: maxWidth,
          maxHeight: 'calc(100% - 80px)',
          margin: '40px',
          padding: '60px',
          boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.06)',
          borderRadius: 0
        }
      }}
    >
      {children}
    </Dialog>
  );
};
